import { useReduxState } from 'hooks';
import { getMessageWithPlaceholders } from 'shared-locales';
import { Link, PublishedProductText } from 'components/common';

import type { Path } from 'shared-types';

interface Props {
  numberOfSteps: number;
  path: Pick<Path, 'title' | 'startDate' | 'endDate'>;
  isPathTypeAdmin?: boolean;
  titleLink?: string;
}

const PathsTileHeader = ({
  numberOfSteps,
  path,
  isPathTypeAdmin,
  titleLink
}: Props) => {
  const { messages, theme } = useReduxState();

  return (
    <div className="header">
      <div className="info">
        <div className="info-text">
          {messages.path}
          <span style={{ margin: '0 7px' }}>{'•'}</span>
          {getMessageWithPlaceholders({
            message: messages.pathsNumberOfSteps,
            placeholders: { numberOfSteps }
          })}
          <PublishedProductText
            endDate={path.endDate}
            startDate={path.startDate}
            includePathTileDot={true}
            useUserTexts={!isPathTypeAdmin}
          />
        </div>
      </div>

      <div className="title">
        {titleLink ? (
          <Link
            href={titleLink}
            linkColor="inherit"
            style={{ display: 'inline-block' }}
          >
            <div className="title-text">{path.title}</div>
          </Link>
        ) : (
          <div className="title-text">{path.title}</div>
        )}
      </div>

      <style jsx>{`
        .info {
          align-items: center;
          display: flex;
          gap: 8px;
        }
        .info-text {
          color: ${theme.textColorLight};
          font-size: 1.3rem;
          font-weight: 600;
        }
        .title {
          margin-top: 5px;
        }
        .title-text {
          color: ${theme.textColor};
          font-size: 1.8rem;
          font-weight: 700;
        }
      `}</style>
    </div>
  );
};

export default PathsTileHeader;
